/* eslint-disable import/no-duplicates */
import {
  Button,
  Autocomplete,
  Paper,
  InputAdornment,
  IconButton,
  createTheme,
  ThemeProvider,
  AutocompleteRenderInputParams,
} from "@mui/material";
import TextFieldMUI from "@mui/material/TextField";
import { Context } from "context/Context";
import { parse } from "date-fns";
import { ptBR } from "date-fns/locale";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { BiSearch } from "react-icons/bi";
import { useEquipesPorEmpresaVendas } from "services/api/Admin_Hierarquia/equipes-por-empresa-vendas";
import { useListarTiposAtendimentos } from "services/api/AppWeb_TipoAtendimento";
import { useCorretoresEmpresaVendas } from "services/api/DadosComum";
import { BeatLoader } from "react-spinners";

import { RootStateOrAny, useSelector } from "react-redux";
import * as SVGIcons from "../../../../../../assets/iconsSVG";
import MaterialUI from "../../../../../../material-UI";
import * as Styles from "./styles";
import { converterObjetoParaString } from "../../../../../../hooks/convertObjectToString";
import { AuthState } from "../../../../../../store/ducks/auth/types";
import { useEmpresasVendasPDV } from "../../../../../../services/api/DadosComum/empresas-vendas-pdv";

const height = 40;
const CustomPaper = (props: any) => {
  return <Paper sx={{ marginTop: 0, borderRadius: 0.5 }} {...props} />;
};

const theme = createTheme({
  shape: {
    borderRadius: 8,
  },
});

interface Props {
  onClickFilter: (item: any) => void;
  loading: boolean;
}

interface DropDownProps {
  label: string;
  value: string;
}

interface pdvFilterProps {
  Visitante: string | undefined | null;
  Corretor: DropDownProps;
  TipoDeVisita: DropDownProps;
  EmpresaDeVendas: DropDownProps;
  Equipe: DropDownProps;
  PeriodoDe: string | null;
  PeriodoAte: string | null;
}

const Filters: React.FC<Props> = (props) => {
  const [filtros, setFiltros] = useState<pdvFilterProps | null>(null);
  const { filtersPDV, setFiltersPDV } = React.useContext(Context);

  const { empresaVendas } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { plantaoVendas }: any = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data: dataCorretoresEmpresasVendasResponse } =
    useCorretoresEmpresaVendas({
      queryKey: `corretores_empresas_header`,
      params: converterObjetoParaString({
        idsEmpresasVendas: empresaVendas?.map((item: any) => item?.id),
      }),
      enabled: true,
    });
  const [corretorList, setCorretorList]: any = useState([]);
  const [corretorValue, setCorretorValue] = useState<any>(null);
  const [tiposAtendimentosList, setTiposAtendimentosList]: any = useState([]);
  const [tiposAtendimentosValue, setTiposAtendimentosValue] =
    useState<any>(null);
  const { data: dataTiposAtendimentosValueResponse } =
    useListarTiposAtendimentos();
  const [empresasVendasList, setEmpresasVendasList]: any = useState([]);
  const [empresaVendaValue, setEmpresaVendaValue] = useState<any>(null);
  const { data: dataEmpresasVendasResponse } = useEmpresasVendasPDV({
    idPdv: plantaoVendas?.id,
    queryKey: "empresas_vendas_pdv_filtros",
  });
  const [equipeList, setEquipeList]: any = useState([]);
  const [equipeValue, setEquipeValue] = useState<any>(null);
  const { data: dataEquipeResponse, refetch: refetchEquipe } =
    useEquipesPorEmpresaVendas({ idEmpresaVendas: empresaVendaValue?.value });
  const [visitante, setVisitante] = useState("");
  const [dateFrom, setDateFrom] = useState<any>(null);
  const [dateTo, setDateTo] = useState<any>(null);

  // passar os valores dos filtros aqui
  const handleFilters = () => {
    setFiltersPDV({
      ...filtersPDV,
      Visitante: visitante === "" ? null : visitante,
      Corretor: corretorValue,
      TipoDeVisita: tiposAtendimentosValue,
      EmpresaDeVendas: empresaVendaValue,
      Equipe: equipeValue,
      PeriodoDe: !dateFrom ? null : moment(dateFrom).format("YYYY-MM-DD"),
      PeriodoAte: !dateTo ? null : moment(dateTo).format("YYYY-MM-DD"),
    });
    props.onClickFilter({
      Visitante: visitante === "" ? null : visitante,
      Corretor: corretorValue,
      TipoDeVisita: tiposAtendimentosValue,
      EmpresaDeVendas: empresaVendaValue,
      Equipe: equipeValue,
      PeriodoDe: !dateFrom ? null : moment(dateFrom).format("YYYY-MM-DD"),
      PeriodoAte: !dateTo ? null : moment(dateTo).format("YYYY-MM-DD"),
    });
  };

  useEffect(() => {
    getFilter();
  }, [filtersPDV]);

  const getFilter = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    if (filtross) {
      const parsedFiltross = JSON.parse(filtross);

      if (parsedFiltross?.PeriodoAte) {
        parsedFiltross.PeriodoAte = moment(parsedFiltross.PeriodoAte).format(
          "YYYY-MM-DD"
        );
      }

      if (parsedFiltross?.PeriodoDe) {
        parsedFiltross.PeriodoDe = moment(parsedFiltross.PeriodoDe).format(
          "YYYY-MM-DD"
        );
      }

      setFiltros(parsedFiltross);
      console.log(parsedFiltross);
    }
  };

  useEffect(() => {
    if (filtros?.Corretor !== null) {
      setCorretorValue(filtros?.Corretor);
    }
    if (filtros?.EmpresaDeVendas !== null) {
      setEmpresaVendaValue(filtros?.EmpresaDeVendas);
    }

    if (filtros?.TipoDeVisita !== null) {
      setTiposAtendimentosValue(filtros?.TipoDeVisita);
    }
    if (
      filtros?.Visitante !== null &&
      filtros?.Visitante !== "" &&
      filtros?.Visitante !== undefined
    ) {
      setVisitante(filtros?.Visitante);
    }
    if (filtros?.PeriodoDe !== null && filtros?.PeriodoDe !== undefined) {
      setDateFrom(parse(filtros?.PeriodoDe, "yyyy-MM-dd", new Date()));
    }
    if (filtros?.PeriodoAte !== null && filtros?.PeriodoAte !== undefined) {
      setDateTo(parse(filtros?.PeriodoAte, "yyyy-MM-dd", new Date()));
    }
    setEquipeValue(filtros?.Equipe);
  }, [filtros]);

  useEffect(() => {
    getCorretores();
  }, [dataCorretoresEmpresasVendasResponse]);

  const getCorretores = () => {
    const formattedData: any = [];
    dataCorretoresEmpresasVendasResponse?.data?.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.idCorretor,
      })
    );
    setCorretorList(formattedData);
  };

  useEffect(() => {
    getTiposAtendimentos();
  }, [dataTiposAtendimentosValueResponse]);

  const getTiposAtendimentos = () => {
    const formattedData: any = [];
    dataTiposAtendimentosValueResponse?.data?.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id,
      })
    );
    setTiposAtendimentosList(formattedData);
  };

  useEffect(() => {
    getEmpresasVendas();
  }, [dataEmpresasVendasResponse]);

  const getEmpresasVendas = () => {
    const formattedData: any = [];
    dataEmpresasVendasResponse?.data?.forEach((item: any) =>
      formattedData.push({
        label: item?.nome,
        value: item?.id365,
      })
    );
    setEmpresasVendasList(formattedData);
  };

  useEffect(() => {
    if (filtros === null) {
      setEquipeValue(null);
    }

    if (empresaVendaValue === null) {
      return;
    }
    refetchEquipe();
  }, [empresaVendaValue]);

  useEffect(() => {
    getEquipes();
  }, [dataEquipeResponse]);

  const getEquipes = () => {
    const formattedData: any = [];
    dataEquipeResponse?.data.forEach((item: any) =>
      formattedData.push({
        label: item?.nomeEquipe,
        value: item?.idEquipe,
      })
    );
    setEquipeList(formattedData);
  };

  const handleClear = () => {
    setDateFrom(null);
    setDateTo(null);
    setVisitante("");
    setCorretorValue(null);
    setTiposAtendimentosValue(null);
    setEmpresaVendaValue(null);
    setEquipeValue(null);
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleFilters();
    }
  };

  return (
    <Styles.Container>
      <Styles.RowSpace>
        <Styles.RowTitle>
          <SVGIcons.FilterIconBlue />
          <Styles.Title>Filtros</Styles.Title>
        </Styles.RowTitle>
        <Button
          onClick={() => handleClear()}
          style={{
            backgroundColor: "transparent",
            color: "#2D5BFF",
            textTransform: "none",
            marginRight: 32,
          }}
          variant="text"
        >
          Limpar
        </Button>
      </Styles.RowSpace>
      <Styles.Space space={48} />
      <Styles.Scroll>
        <Styles.Row>
          <Styles.LocalizationProvider
            locale={ptBR}
            dateAdapter={MaterialUI.AdapterDateFns}
          >
            <Styles.Column>
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={dateFrom}
                maxDate={new Date()}
                components={{
                  OpenPickerIcon: SVGIcons.CalendarIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setDateFrom(newValue)}
                renderInput={(params: any) => (
                  <>
                    <Styles.InputLable>Período</Styles.InputLable>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Data *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.Column>
            <Styles.ColumnAlign>
              <Styles.InputLable>até</Styles.InputLable>
            </Styles.ColumnAlign>
            <Styles.Column>
              <Styles.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={dateTo}
                components={{
                  OpenPickerIcon: SVGIcons.CalendarIcon,
                }}
                minDate={dateFrom}
                maxDate={new Date()}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) => setDateTo(newValue)}
                renderInput={(params: any) => (
                  <>
                    <Styles.Space space={26} />
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Data *"
                      fullWidth
                    />
                  </>
                )}
              />
            </Styles.Column>
          </Styles.LocalizationProvider>
        </Styles.Row>
        <Styles.Space space={32} />
        <Styles.Column>
          <Styles.InputLable>Visitante</Styles.InputLable>
          <TextFieldMUI
            value={visitante}
            onChange={(e: any) => setVisitante(e.target.value)}
            onKeyPress={handleKeyPress}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton style={{ marginRight: "-20px" }}>
                    <BiSearch />
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                height,
                padding: "0",
                borderRadius: 8,
              },
            }}
            style={{ height }}
            InputLabelProps={{
              style: {
                height,
              },
            }}
            size="small"
            variant="outlined"
            label=""
            placeholder=""
            fullWidth
          />
        </Styles.Column>
        <Styles.Space space={32} />
        <Styles.Column>
          <Styles.InputLable>Corretor</Styles.InputLable>
          <ThemeProvider theme={theme}>
            <Autocomplete
              sx={{ backgroundColor: "#fff", border: "none" }}
              options={corretorList}
              value={corretorValue}
              onChange={(event: any, value: any) => {
                setCorretorValue(value);
              }}
              autoHighlight
              size="small"
              fullWidth
              PaperComponent={CustomPaper}
              isOptionEqualToValue={(option: any, value: any) =>
                option?.value === value?.value
              }
              renderInput={(params: AutocompleteRenderInputParams) => (
                <Styles.CustomTextField {...params} placeholder="" />
              )}
            />
          </ThemeProvider>
        </Styles.Column>
        <Styles.Space space={32} />
        <Styles.Column>
          <Styles.InputLable>Tipo de visita</Styles.InputLable>
          <ThemeProvider theme={theme}>
            <Autocomplete
              sx={{ backgroundColor: "#fff", border: "none" }}
              options={tiposAtendimentosList}
              value={tiposAtendimentosValue}
              onChange={(event: any, value: any) => {
                setTiposAtendimentosValue(value);
              }}
              autoHighlight
              size="small"
              fullWidth
              PaperComponent={CustomPaper}
              isOptionEqualToValue={(option: any, value: any) =>
                option?.value === value?.value
              }
              renderInput={(params: AutocompleteRenderInputParams) => (
                <Styles.CustomTextField {...params} placeholder="" />
              )}
            />
          </ThemeProvider>
        </Styles.Column>
        <Styles.Space space={32} />
        <Styles.Column>
          <Styles.InputLable>Empresa de vendas</Styles.InputLable>
          <ThemeProvider theme={theme}>
            <Autocomplete
              sx={{ backgroundColor: "#fff", border: "none" }}
              options={empresasVendasList}
              value={empresaVendaValue}
              onChange={(event: any, value: any) => {
                setEmpresaVendaValue(value);
              }}
              autoHighlight
              size="small"
              fullWidth
              PaperComponent={CustomPaper}
              isOptionEqualToValue={(option, value) =>
                option?.value === value?.value
              }
              renderInput={(params: AutocompleteRenderInputParams) => (
                <Styles.CustomTextField {...params} placeholder="" />
              )}
            />
          </ThemeProvider>
        </Styles.Column>
        <Styles.Space space={32} />
        <Styles.Column>
          <Styles.InputLable>Equipe</Styles.InputLable>
          <ThemeProvider theme={theme}>
            <Autocomplete
              sx={{ backgroundColor: "#fff", border: "none" }}
              options={equipeList}
              value={equipeValue}
              onChange={(event: any, value: any) => {
                setEquipeValue(value);
              }}
              autoHighlight
              size="small"
              fullWidth
              isOptionEqualToValue={(option, value) =>
                option?.value === value?.value
              }
              PaperComponent={CustomPaper}
              renderInput={(params: AutocompleteRenderInputParams) => (
                <Styles.CustomTextField {...params} placeholder="" />
              )}
            />
          </ThemeProvider>
        </Styles.Column>
        <Styles.Space space={32} />
      </Styles.Scroll>
      <Styles.ContainerButton>
        <Button
          onClick={() => handleFilters()}
          sx={{
            background: "linear-gradient(to right, #4a76fb, #06d986)",
            color: "white",
            height: 50,
          }}
          style={{ color: "#fff", marginRight: 8, textTransform: "none" }}
          variant="contained"
          fullWidth
        >
          {props?.loading ? (
            <BeatLoader color="#fff" size={10} />
          ) : (
            "Aplicar filtro"
          )}
        </Button>
      </Styles.ContainerButton>
    </Styles.Container>
  );
};

export default Filters;
